module.exports = __webpack_public_path__ + "img/fig20.5bb41a5f.jpg";